function replaceAccents(value) {
  if (!value) {
    return '';
  }

  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export default replaceAccents;
